export const FETCH_CREATE_ORGANISATION_REQUEST = 'FETCH_CREATE_ORGANISATION_REQUEST'
export const FETCH_CREATE_ORGANISATION_SUCCESS = 'FETCH_CREATE_ORGANISATION_SUCCESS'
export const FETCH_CREATE_ORGANISATION_FALUIRE = 'FETCH_CREATE_ORGANISATION_FALUIRE'
